<div class="sidenav-hold">
  @if (hasIconTypeMenuItem()) {
    <div class="icon-menu">
      <!-- Icon menu separator -->
      <div class="mt-1 mb-1 nav-item-sep">
        <mat-divider [ngStyle]="{margin: '0 -24px'}" />
        <span class="text-muted icon-menu-title">{{iconTypeMenuTitle()}}</span>
      </div>
      <!-- Icon menu items -->
      @for (item of menuItems(); track item) {
        <div class="icon-menu-item">
          @if (!item.disabled && item.type === 'icon') {
            <button mat-raised-button [matTooltip]="item.tooltip" routerLink="/{{item.state}}"
              routerLinkActive="mat-bg-primary">
              <mat-icon>{{item.icon}}</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }

  <ul appDropdown class="sidenav">
    @for (item of menuItems(); track item) {
      <li appDropdownLink routerLinkActive="open">
        @if (item.type === 'separator') {
          <div class="nav-item-sep">
            <mat-divider />
            <span class="text-muted">{{item.name | translate}}</span>
          </div>
        }
        @if (!item.disabled && item.type !== 'separator' && item.type !== 'icon') {
          <div class="lvl1">
            @if (item.type === 'link') {
              <a routerLink="/{{item.state}}" appDropdownToggle matRipple>
                <mat-icon>{{item.icon}}</mat-icon>
                <span class="item-name lvl1">{{item.name | translate}}</span>
                <span class="sidenav__spacer"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}">{{ badge.value }}</span>
                }
              </a>
            }
            @if (item.type === 'extLink') {
              <a [href]="item.state" appDropdownToggle matRipple target="_blank">
                <mat-icon>{{item.icon}}</mat-icon>
                <span class="item-name lvl1">{{item.name | translate}}</span>
                <span class="sidenav__spacer"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}">{{ badge.value }}</span>
                }
              </a>
            }
            <!-- DropDown -->
            @if (item.type === 'dropDown') {
              <a appDropdownToggle matRipple>
                <mat-icon>{{item.icon}}</mat-icon>
                <span class="item-name lvl1">{{item.name | translate}}</span>
                <span class="sidenav__spacer"></span>
                @for (badge of item.badges; track badge) {
                  <span class="menuitem-badge mat-bg-{{ badge.color }}" [ngStyle]="{background: badge.color}">{{ badge.value }}</span>
                }
                <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
              </a>
            }
            <!-- LEVEL 2 -->
            @if (item.type === 'dropDown') {
              <ul class="submenu lvl2" appDropdown>
                @for (itemLvL2 of item.sub; track itemLvL2) {
                  <li appDropdownLink routerLinkActive="open">
                    @if (itemLvL2.type !== 'dropDown') {
                      <a routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state}}" appDropdownToggle
                        matRipple>
                        <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
                        <span class="sidenav__spacer"></span>
                      </a>
                    }
                    @if (itemLvL2.type === 'dropDown') {
                      <a appDropdownToggle matRipple>
                        <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
                        <span class="sidenav__spacer"></span>
                        <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
                      </a>
                    }
                    <!-- LEVEL 3 -->
                    @if (itemLvL2.type === 'dropDown') {
                      <ul class="submenu lvl3" appDropdown>
                        @for (itemLvL3 of itemLvL2.sub; track itemLvL3) {
                          <li appDropdownLink routerLinkActive="open">
                            <a routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}" appDropdownToggle
                              matRipple>
                              <span class="item-name lvl3">{{itemLvL3.name | translate}}</span>
                            </a>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </div>
        }
      </li>
    }
  </ul>
</div>